const DEALER_ROLE = 'dealer'
const HTA_DEALER_ROLE = 'hta dealer'
const HTS_DEALER_ROLE = 'hts dealer'
const CS_ROLE = 'cs'
const SALES_ROLE = 'sales'
const LOGISTIC_ROLE = 'logistic'
const OPERATION_ROLE = 'operation'

const ALL_ROLES = [
  DEALER_ROLE,
  HTS_DEALER_ROLE,
  HTA_DEALER_ROLE,
  CS_ROLE,
  SALES_ROLE,
  LOGISTIC_ROLE,
  OPERATION_ROLE,
]

module.exports = {
  DEALER_ROLE,
  HTS_DEALER_ROLE,
  HTA_DEALER_ROLE,
  CS_ROLE,
  SALES_ROLE,
  LOGISTIC_ROLE,
  OPERATION_ROLE,
  ALL_ROLES,
}
